<template>
    <div>
        <table class="min-w-full divide-y divide-gray-200 relative">
            <thead class="sticky top-0 bg-gray-50 z-10">
                <tr>
                    <th
                        class="sticky left-0 px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {{ $t('messages.student') }}
                    </th>
                    <th
                        v-for="activity in activities"
                        :key="activity.url"
                        class="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        <a :href="activity.url">{{ activity.title }}</a>
                    </th>
                </tr>
                <tr>
                    <th
                        class="sticky left-0 bg-white px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        -
                    </th>
                    <th
                        v-for="activity in activities"
                        class="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        <span
                            v-for="activityDimension in activity.activity_dimensions"
                            :title="activityDimension.dimension.title"
                        >
                            D{{ activityDimension.dimension.number }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    class="odd:bg-white even:bg-gray-50"
                    v-for="(student, studentIndex) in filteredResponses"
                    :key="studentIndex"
                >
                    <td
                        class="sticky left-0 bg-white px-4 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                    >
                        <InertiaLink :href="student.student.links.show" class="text-indigo-500">
                            {{ student.student.full_name }}
                        </InertiaLink>
                    </td>
                    <td
                        v-for="(score, scoreIndex) in student.scores"
                        :key="`${colors}_${displayOption}_${scoreIndex}_${studentIndex}`"
                        v-bind:class="getColor(score)"
                        class="text-center px-4 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                    >
                        <div class="flex items-center">
                            <div class="mr-1">
                                <span v-if="displayOption === 'score'">
                                    {{ score.score }}
                                </span>
                                <span v-else>
                                    {{ score.letter }}
                                </span>
                            </div>
                            <div v-if="score.adapted">
                                <svg
                                    class="w-4 h-4 text-indigo-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    methods: {
        getColor(score) {
            if (this.colors === false) {
                return '';
            }

            return score.bgColor;
        },
    },
    data() {
        return {};
    },
    computed: {
        filteredResponses: function () {
            if (!this.search) {
                return this.responsesTableValues;
            }

            return this.responsesTableValues.filter((student) => {
                return student.student.full_name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
            });
        },
    },
    props: {
        responsesTableValues: {
            type: Array,
            default: () => [],
        },
        activities: {
            type: Array,
            default: () => [],
        },
        displayOption: {
            type: String,
        },
        colors: {
            type: Boolean,
            default: false,
        },
        search: {
            type: String,
            default: '',
            required: false,
        },
    },
};
</script>
